export default __webpack_public_path__ + "static/media/vote_proxy_2.2918d520.jpg";